import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 14px;
  width: 100%;
`;

export const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
`;

export const Title = styled.span`
  color: #000;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;

export const Text = styled.span`
  color: #000;
  font-variant-numeric: lining-nums tabular-nums;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 17px;
  border-radius: 2px;
  background: #FFF;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.10);
`;

export const InnerHead = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #CCD6DE;
`;

export const InnerFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 12px;
`;

export const Button = styled.button`
  border-radius: 2px;
  border: 1px solid var(--primary-500-main, #1271A6);
  padding: 6px 12px;
  color: var(--primary-500-main, #1271A6);
  background: transparent;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
`;
